import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Breadcrumb from '../../components/ui/Breadcrumb';
import FloatingAIChat from '../../components/ui/FloatingAIChat';
import Button from '../../components/ui/Button';

const ActivityInterface = () => {
  const navigate = useNavigate();

  const breadcrumbItems = [
    { label: 'Início', path: '/dashboard-home' },
    { label: 'Atividades', path: '/activity-interface', isActive: true }
  ];

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-16">
        <div className="container mx-auto px-6 py-8">
          <Breadcrumb customItems={breadcrumbItems} />
          
          <div className="text-center py-16">
            <div className="w-24 h-24 bg-muted rounded-full flex items-center justify-center mx-auto mb-6">
              <svg className="w-12 h-12 text-muted-foreground" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
            </div>
            
            <h1 className="text-3xl font-bold text-foreground mb-4">Sem Atividades Disponíveis</h1>
            <p className="text-muted-foreground mb-8 max-w-md mx-auto">
              Não há atividades disponíveis no momento. Entre em contato com o administrador para solicitar acesso.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button onClick={() => navigate('/dashboard-home')}>
                Voltar ao Dashboard
              </Button>
              <Button variant="outline" onClick={() => navigate('/course-detail-view')}>
                Ver Cursos
              </Button>
            </div>
          </div>
        </div>
      </main>
      <FloatingAIChat />
    </div>
  );
};

export default ActivityInterface;